import React from 'react';
import {Button, Modal} from "react-bootstrap";

export const DeleteDesignModal = ({show, onHide, deleteOnClick}) => (
    <Modal show={show}
           onHide={onHide}>
        <Modal.Header closeButton>
            <Modal.Title>Delete Design</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            Are you sure you want to delete this design?
        </Modal.Body>
        <Modal.Footer>
            <Button onClick={onHide}>Cancel</Button>
            <Button onClick={deleteOnClick} className="btn-orange">Yes</Button>
        </Modal.Footer>
    </Modal>
);